export const images = {
  landingLogo: new URL("../../assets/images/smaul_logo.png", import.meta.url).href,
  heroLogo: new URL("../../assets/images/smaul_FV.png", import.meta.url).href,
  heroBackground: new URL("../../assets/images/bg_FV.png", import.meta.url).href,
  heroModel: new URL("../../assets/images/character_FV.png", import.meta.url).href,
  heroRibbon: new URL("../../assets/images/ribbon_FV.svg", import.meta.url).href,
  heroRing: new URL("../../assets/images/ring_FV.svg", import.meta.url).href,
  propallyLogo: new URL("../../assets/images/Propally.png", import.meta.url).href,
  ctaButton: new URL("../../assets/images/button_CTA.png", import.meta.url).href,
  ribbonBlack: new URL("../../assets/images/ribbon_Black.png", import.meta.url).href,
  ribbonWhite: new URL("../../assets/images/ribbon_White.png", import.meta.url).href,
  pointSystem: new URL("../../assets/images/point_system.png", import.meta.url).href,
  pointListener: new URL("../../assets/images/point_listener.png", import.meta.url).href,
  pointCall: new URL("../../assets/images/point_call.png", import.meta.url).href,
  pointExpense: new URL("../../assets/images/point_expense.png", import.meta.url).href,
  pointBribery: new URL("../../assets/images/point_bribery.png", import.meta.url).href,
  whyBubble: new URL("../../assets/images/why_bubble.png", import.meta.url).href,
  whySpecialization: new URL("../../assets/images/why_specialization.png", import.meta.url).href,
  whyCompetition: new URL("../../assets/images/why_competition.png", import.meta.url).href,
  reasonSystem: new URL("../../assets/images/reason_system.png", import.meta.url).href,
};

// 配置は Figma「スマウルLP」MV（node 382:2）に合わせた MV 内の座標（px）
export type HeroPoint = {
  label: string[];
  // 数字部分だけ Roboto で表示する（例: 「20」社）
  valueNumber?: string;
  value: string;
  valueSize: number;
  labelLetterSpacing: string;
  top: number;
  textTop: number;
  ringRotate: number;
};

export const heroPoints: HeroPoint[] = [
  {
    label: ["ワンルーム特化", "提携不動産会社"],
    valueNumber: "20",
    value: "社",
    valueSize: 24,
    labelLetterSpacing: "0.05em",
    top: 193,
    textTop: 33,
    ringRotate: -15,
  },
  {
    label: ["仲介手数料"],
    value: "無料",
    valueSize: 24,
    labelLetterSpacing: "0.1em",
    top: 295,
    textTop: 38,
    ringRotate: -135,
  },
  {
    label: ["不動産会社", "からの営業電話"],
    value: "一切ナシ",
    valueSize: 20,
    labelLetterSpacing: "0.05em",
    top: 398,
    textTop: 36,
    ringRotate: 165,
  },
];
